import React, { useState, useEffect } from 'react';

import NuxeoClient from '../../clients/NuxeoClient';
import Autocomplete from '../ui/Autocomplete';

import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';

import { useI18n } from "../../I18nProvider";

export default function DeliveryType(props) {
    const appText = useI18n();

    const [fetchedData, setFetchedData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (props.submissionType === "Marketing & PR") {
            _loadMarketingChannels();
        };
    }, [props.submissionType]);

    async function _loadMarketingChannels() {
        await NuxeoClient
            .instance()
            .fetchMarketingChannels()
            .then((response) => {
                setFetchedData(response);
                setIsLoading(false);
            });
    };

    const handleChange = (value) => {
        props.handleChange('deliveryType', value.label);
    };

    return (
        <Tooltip arrow title={appText.T846}>
            <Grid item={true} xs={12}>
                <div id="contract">
                    <InputLabel className="field-label field-dropdown" required>
                        {/* Delivery Type */}
                        {appText.T841}
                    </InputLabel>
                    <Autocomplete
                        type={'single'}
                        handleChange={handleChange}
                        data={fetchedData}
                        dataType={'deliveryType'}
                        mapVariable={'label'}
                        setFilterData={() => null}
                        value={props.value}
                        isLoading={isLoading}
                    />
                </div>
            </Grid>
        </Tooltip>
    );
};